






































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import ProductForView from "../../../store/entities/productForView";
import Product from "../../../store/entities/product";
import Barcode from "../../components/bar-code.vue";
import ProductHistory from "./product-history.vue";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";

@Component({
  components: { "bar-code": Barcode, "product-history": ProductHistory },
})
export default class ViewProduct extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  product: ProductForView = new ProductForView();
  code: string = "";
  spinShow: boolean = false;
  id: number = 0;
  dataChildProducts = [];
  isClient() {
    return !_.isNil(this.$store.state.session.client);
  }
  isTenant() {
    return !_.isNil(this.$store.state.session.tenant);
  }
  cancel() {
    (this.$refs.viewProductForm as any).resetFields();
    this.$emit("input", false);
    this.$root.$router.push({ name: "product" });
  }
  get activeText() {
    return this.product.isActive ? Util.L("Actived") : Util.L("NoActive");
  }
  async created() {
    this.spinShow = true;
    try {
      this.id = +this.$root.$router.currentRoute.params.id;
      await this.$store
        .dispatch({
          type: "product/get",
          data: { id: this.id },
        })
        .then((result) => {
          this.product = result;
          this.code = this.product.sku;
          this.product.imageURL = Util.getAppUrlImage(this.product.thumbnailUrl);
          var plength = Util.isNull(this.product.length)
            ? 0
            : this.product.length;
          var pwidth = Util.isNull(this.product.width) ? 0 : this.product.width;
          var pheight = Util.isNull(this.product.height)
            ? 0
            : this.product.height;
          this.product.dimension = `${plength}x${pwidth}x${pheight}`;
          var clength = Util.isNull(this.product.caseLength)
            ? 0
            : this.product.caseLength;
          var cwidth = Util.isNull(this.product.caseWidth)
            ? 0
            : this.product.caseWidth;
          var cheight = Util.isNull(this.product.caseHeight)
            ? 0
            : this.product.caseHeight;
          this.product.caseDimension = `${clength}x${cwidth}x${cheight}`;
          this.dataChildProducts = this.product.items;
          this.reorderDataChildProducts();

          this.$store.dispatch({
            type: "product/getProductHistory",
            data: { id: this.id },
          });
        });
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  childProductColumns = [
    {
      title: Util.L("Order"),
      width: 50,
      key: "orderNo",
    },
    {
      title: Util.L("Client"),
      key: "clientName",
    },
    {
      title: Util.L("Category"),
      key: "categoryName",
    },
    {
      title: Util.L("Unit"),
      key: "unitName",
    },
  ];

  reorderDataChildProducts() {
    let index = 0;
    this.dataChildProducts.forEach(function (item) {
      item.orderNo = index + 1;
      index++;
    });
  }
}
